module.exports = __webpack_public_path__ + "img/login.0b24e1d4.png";